module.exports = __webpack_public_path__ + "img/flag.f0591c80.svg";